import { CoxAnalyticsConfig } from "@coxauto-ui/core-models-analytics-cox-analytics";
import { CxmEnvironmentValues } from "@coxauto-ui/cxm/interfaces";
import { getEnvConfig } from "@coxauto-ui/core/get-env";

const getInitialCoxAnalyticsConfig = (): CoxAnalyticsConfig => {
  const { GTM_ENV } = getEnvConfig<CxmEnvironmentValues>("cxm");
  const isProduction = GTM_ENV === "prod";

  return {
    isProduction
  };
};

export default getInitialCoxAnalyticsConfig;
